import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02781157"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-wrapper mb-4 d-block d-sm-flex align-items-start align-items-xl-center justify-content-between py-1" }
const _hoisted_2 = { class: "filter mb-0 text-start d-flex flex-nowrap flex-sm-wrap list-unstyled px-3 mx-n3 pt-0 pt-xl-1 pb-0" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "filter-overlay-header p-1 d-flex d-sm-none justify-content-center align-items-center" }
const _hoisted_5 = { class: "flex-grow-1 text-center position-relative py-1 fw-bold fs-5" }
const _hoisted_6 = { class: "filter-overlay-body p-3" }
const _hoisted_7 = {
  key: 0,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_8 = { class: "switch-wrapper w-100" }
const _hoisted_9 = { class: "switch-body-right" }
const _hoisted_10 = { class: "form-floating mb-3" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "form-floating mb-3" }
const _hoisted_14 = ["id"]
const _hoisted_15 = ["for"]
const _hoisted_16 = {
  key: 1,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_17 = ["id", "checked", "value", "onChange"]
const _hoisted_18 = ["for"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_21 = ["id", "checked", "value", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 3,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_25 = ["id", "checked", "value", "onChange"]
const _hoisted_26 = ["for"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 4,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_29 = ["id", "checked", "value", "onChange"]
const _hoisted_30 = ["for"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 5,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_33 = { class: "switch-wrapper" }
const _hoisted_34 = {
  key: 0,
  class: "switch-body-left d-flex"
}
const _hoisted_35 = { class: "form-floating pe-1" }
const _hoisted_36 = ["id"]
const _hoisted_37 = ["for"]
const _hoisted_38 = { class: "form-floating ps-1" }
const _hoisted_39 = ["id"]
const _hoisted_40 = ["for"]
const _hoisted_41 = {
  key: 1,
  class: "switch-body-right d-flex"
}
const _hoisted_42 = { class: "form-floating pe-1" }
const _hoisted_43 = ["id"]
const _hoisted_44 = ["for"]
const _hoisted_45 = { class: "form-floating ps-1" }
const _hoisted_46 = ["id"]
const _hoisted_47 = ["for"]
const _hoisted_48 = {
  key: 6,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_49 = { class: "form-check pb-2" }
const _hoisted_50 = ["id"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "form-check pb-2" }
const _hoisted_53 = ["id"]
const _hoisted_54 = ["for"]
const _hoisted_55 = {
  key: 7,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_56 = ["id", "checked", "value", "onChange"]
const _hoisted_57 = ["for"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 8,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_60 = ["id", "checked", "value", "onChange"]
const _hoisted_61 = ["for"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = {
  key: 9,
  class: "filter-overlay-body-inner d-flex flex-wrap d-sm-block"
}
const _hoisted_64 = ["id", "checked", "value", "onChange"]
const _hoisted_65 = ["for"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "link-dark fw-medium fs-5" }, "Alle Förderprogramme anzeigen", -1))
const _hoisted_68 = {
  class: "d-flex align-items-center toggle-wrapper",
  for: "toggle"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator-v d-none d-md-block mx-2" }, null, -1))
const _hoisted_70 = { class: "icons" }
const _hoisted_71 = ["checked", "true-value", "false-value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Switch = _resolveComponent("Switch")!
  const _component_FilterReset = _resolveComponent("FilterReset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.overlay)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "filter-overlay-bg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {;(_ctx.overlay = false), _ctx.addScroll()})
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measureOverviewFilter, (item, identifier, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("li", {
          key: index,
          onClick: _withModifiers(($event: any) => (_ctx.toggleFilter(index)), ["stop"]),
          class: "me-1 mb-1 mb-xl-0"
        }, [
          (
            identifier !== 'statesFilter' && identifier !== 'measureBonusFilter'
          )
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["btn btn-sm rounded-pill text-nowrap", 
            _ctx.overlay === true && _ctx.selectedFilterMenu === index
              ? 'btn-filter-active'
              : ``
          ])
              }, _toDisplayString(item.label) + _toDisplayString(_ctx.getActiveFilterItemsPostfix(item.internalIdentifier)), 3))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            name: "bottom-sheet-slide",
            appear: ""
          }, {
            default: _withCtx(() => [
              (_ctx.overlay && index === _ctx.selectedFilterMenu)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "filter-overlay filter-overlay-transition rounded-1",
                    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {;(_ctx.overlay = !_ctx.overlay), _ctx.addScroll()}),
                        "aria-hidden": "true",
                        class: "btn btn-link flycon flycon-top flycon-24 flycon-close text-dark lh-0 rounded-circle p-1 m-1 border-0 position-absolute end-0"
                      }, " ­ ")
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      (identifier === 'temporallyFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "2018",
                                    max: "2099",
                                    step: "1",
                                    class: "form-control",
                                    id: 'validity-temporally-0-' + index,
                                    placeholder: "Von",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.temporally.from) = $event)),
                                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateTemporallyFilter && _ctx.updateTemporallyFilter(...args))),
                                    onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isNumberKey($event)))
                                  }, null, 40, _hoisted_11), [
                                    [_vModelText, _ctx.temporally.from]
                                  ]),
                                  _createElementVNode("label", {
                                    for: 'validity-temporally-0-' + index
                                  }, "Von:", 8, _hoisted_12)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    min: "2018",
                                    max: "2099",
                                    step: "1",
                                    class: "form-control",
                                    id: 'validity-temporally-1-' + index,
                                    placeholder: "bis",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.temporally.to) = $event)),
                                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updateTemporallyFilter && _ctx.updateTemporallyFilter(...args))),
                                    onKeydown: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isNumberKey($event)))
                                  }, null, 40, _hoisted_14), [
                                    [_vModelText, _ctx.temporally.to]
                                  ]),
                                  _createElementVNode("label", {
                                    for: 'validity-temporally-1-' + index
                                  }, "Bis:", 8, _hoisted_15)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'measureTypesFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measureTypes, (measureType, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'area-' + index,
                                  checked: measureType.isActive,
                                  value: measureType.label,
                                  onChange: ($event: any) => (
                      _ctx.updateFilterItem(measureType, 'measureTypesFilter')
                    )
                                }, null, 40, _hoisted_17),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'area-' + index
                                }, _toDisplayString(measureType.label), 9, _hoisted_18)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measureTypes, (measureType, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([{ 'btn-filter-active': measureType.isActive }, "btn btn-sm rounded-pill"]),
                                  onClick: ($event: any) => (_ctx.updateFilterItem(measureType, 'measureTypesFilter'))
                                }, _toDisplayString(measureType.label), 11, _hoisted_19)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'locationsFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'location-' + index,
                                  checked: location.isActive,
                                  value: location.label,
                                  onChange: ($event: any) => (_ctx.updateFilterItem(location, 'locationsFilter'))
                                }, null, 40, _hoisted_21),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'location-' + index
                                }, _toDisplayString(location.label), 9, _hoisted_22)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': location.isActive }]),
                                  onClick: ($event: any) => (_ctx.updateFilterItem(location, 'locationsFilter'))
                                }, _toDisplayString(location.label), 11, _hoisted_23)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'targetAreaFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetAreas, (targetArea, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'targetArea-' + index,
                                  checked: targetArea.isActive,
                                  value: targetArea.label,
                                  onChange: ($event: any) => (_ctx.updateFilterItem(targetArea, 'targetAreaFilter'))
                                }, null, 40, _hoisted_25),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'targetArea-' + index
                                }, _toDisplayString(targetArea.label), 9, _hoisted_26)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetAreas, (targetArea, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': targetArea.isActive }]),
                                  onClick: ($event: any) => (_ctx.updateFilterItem(targetArea, 'targetAreaFilter'))
                                }, _toDisplayString(targetArea.label), 11, _hoisted_27)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'formsFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'form-' + index,
                                  checked: form.isActive,
                                  value: form.label,
                                  onChange: ($event: any) => (_ctx.updateFilterItem(form, 'formsFilter'))
                                }, null, 40, _hoisted_29),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'form-' + index
                                }, _toDisplayString(form.label), 9, _hoisted_30)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': form.isActive }]),
                                  onClick: ($event: any) => (_ctx.updateFilterItem(form, 'formsFilter'))
                                }, _toDisplayString(form.label), 11, _hoisted_31)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'dimensionsFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_Switch, {
                                switchName: 'toggleMeasurement',
                                switchLeftId: 'dimension',
                                switchRightId: 'hectare',
                                switchLeftLabel: 'Meter',
                                switchRightLabel: 'Hektar',
                                onGetValue: _ctx.getSwitchToggleValue
                              }, null, 8, ["onGetValue"]),
                              (_ctx.switchToggleValue !== `hectare`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: 'dimension-0-' + index,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.widthFilterValue.min) = $event)),
                                        onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.updateWidthFilter && _ctx.updateWidthFilter(...args))),
                                        placeholder: "Breite in m"
                                      }, null, 40, _hoisted_36), [
                                        [_vModelText, _ctx.widthFilterValue.min]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'dimension-0-' + index
                                      }, "Von:", 8, _hoisted_37)
                                    ]),
                                    _createElementVNode("div", _hoisted_38, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: 'dimension-1-' + index,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.widthFilterValue.max) = $event)),
                                        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateWidthFilter && _ctx.updateWidthFilter(...args))),
                                        placeholder: "Länge in m"
                                      }, null, 40, _hoisted_39), [
                                        [_vModelText, _ctx.widthFilterValue.max]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'dimension-1-' + index
                                      }, "Bis:", 8, _hoisted_40)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.switchToggleValue === `hectare`)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: 'hectare-0-' + index,
                                        placeholder: "Min. 0,01 ha",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.hectareFilterValue.min) = $event)),
                                        onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.updateHectareFilter && _ctx.updateHectareFilter(...args))),
                                        step: "0.01"
                                      }, null, 40, _hoisted_43), [
                                        [_vModelText, _ctx.hectareFilterValue.min]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'hectare-0-' + index
                                      }, "Von:", 8, _hoisted_44)
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: 'hectare-1-' + index,
                                        placeholder: "Max. 0,25 ha",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.hectareFilterValue.max) = $event)),
                                        onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.updateHectareFilter && _ctx.updateHectareFilter(...args))),
                                        step: "0.01"
                                      }, null, 40, _hoisted_46), [
                                        [_vModelText, _ctx.hectareFilterValue.max]
                                      ]),
                                      _createElementVNode("label", {
                                        for: 'hectare-1-' + index
                                      }, "Bis:", 8, _hoisted_47)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'measureBonusFilter' && false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: 'bonus-0-' + index
                              }, null, 8, _hoisted_50),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: 'bonus-0-' + index
                              }, "Ja", 8, _hoisted_51)
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: 'bonus-1-' + index
                              }, null, 8, _hoisted_53),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: 'bonus-1-' + index
                              }, "Nein", 8, _hoisted_54)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'commitmentTimesFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commitmentTimes, (commitmentTime, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'commitmentTime-' + index,
                                  checked: commitmentTime.isActive,
                                  value: commitmentTime.label,
                                  onChange: ($event: any) => (
                      _ctx.updateFilterItem(commitmentTime, 'commitmentTimesFilter')
                    )
                                }, null, 40, _hoisted_56),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'commitmentTime-' + index
                                }, _toDisplayString(commitmentTime.label), 9, _hoisted_57)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commitmentTimes, (commitmentTime, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': commitmentTime.isActive }]),
                                  onClick: ($event: any) => (
                      _ctx.updateFilterItem(commitmentTime, 'commitmentTimesFilter')
                    )
                                }, _toDisplayString(commitmentTime.label), 11, _hoisted_58)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'sceneFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenes, (scene, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'scene-' + index,
                                  checked: scene.isActive,
                                  value: scene.label,
                                  onChange: ($event: any) => (_ctx.updateFilterItem(scene, 'sceneFilter'))
                                }, null, 40, _hoisted_60),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'scene-' + index
                                }, _toDisplayString(scene.label), 9, _hoisted_61)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenes, (scene, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': scene.isActive }]),
                                  onClick: ($event: any) => (_ctx.updateFilterItem(scene, 'sceneFilter'))
                                }, _toDisplayString(scene.label), 11, _hoisted_62)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (identifier === 'supportProgramsFilter')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportPrograms.slice(
                    0,
                    _ctx.hasLimit
                  ), (supportProgram, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "form-check pb-2 d-none d-sm-block",
                                key: index
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'supportProgram-' + index,
                                  checked: supportProgram.isActive,
                                  value: supportProgram.label,
                                  onChange: ($event: any) => (
                      _ctx.updateFilterItem(supportProgram, 'supportProgramsFilter')
                    )
                                }, null, 40, _hoisted_64),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: 'supportProgram-' + index
                                }, _toDisplayString(supportProgram.label), 9, _hoisted_65)
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportPrograms, (supportProgram, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-sm-none mb-1 me-1",
                                key: index
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["btn btn-sm rounded-pill", { 'btn-filter-active': supportProgram.isActive }]),
                                  onClick: ($event: any) => (
                      _ctx.updateFilterItem(supportProgram, 'supportProgramsFilter')
                    )
                                }, _toDisplayString(supportProgram.label), 11, _hoisted_66)
                              ]))
                            }), 128)),
                            (_ctx.supportPrograms.length > 6)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "d-none d-sm-flex link-expand",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.limitTo(_ctx.supportPrograms)))
                                }, [
                                  _hoisted_67,
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["return-link flycon flycon-20 flycon-start", 
                      _ctx.hasLimit === 6
                        ? 'flycon-chevron-down'
                        : 'flycon-chevron-up'
                    ])
                                  }, "­", 2)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ], 8, _hoisted_3)), [
          [_vShow, 
          identifier !== 'statesFilter' && identifier !== 'measureBonusFilter'
        ]
        ])
      }), 128))
    ]),
    _createElementVNode("label", _hoisted_68, [
      _createVNode(_component_FilterReset, { onResetAll: _ctx.resetAllSettings }, null, 8, ["onResetAll"]),
      _hoisted_69,
      _createElementVNode("div", {
        class: _normalizeClass(["toggle d-none d-md-block", _ctx.viewIconToggle === true ? 'enable' : 'disable'])
      }, [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("button", {
            "aria-hidden": "true",
            class: "bg-transparent flycon flycon-top flycon-16 flycon-list-details text-dark lh-0 rounded-circle p-1 border-0",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateIconToggle(false)))
          }, " ­ "),
          _createElementVNode("button", {
            "aria-hidden": "true",
            class: "bg-transparent flycon flycon-top flycon-16 flycon-align-left text-dark lh-0 rounded-circle p-1 border-0",
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateIconToggle(true)))
          }, " ­ ")
        ]),
        _createElementVNode("input", {
          id: "toggle",
          name: "toggle",
          type: "checkbox",
          checked: _ctx.viewIconToggle === true,
          "true-value": _ctx.viewIconToggle === true,
          "false-value": _ctx.viewIconToggle === false
        }, null, 8, _hoisted_71)
      ], 2)
    ])
  ]))
}